import { SUBMIT_FORM_INTENT } from '../constants';
import type { GetWorklistItemQuery } from 'generated/graphql';
import type { SubmitFormIntent } from '../constants';

export const getPayloadCaseId = (
  mode: SubmitFormIntent,
  currentCase: Nullable<GetWorklistItemQuery['worklistItem']>,
  shouldUpdateClassifications: boolean
): Nullable<string> => {
  return mode === SUBMIT_FORM_INTENT.SAVE || shouldUpdateClassifications ? currentCase?.smid : null;
};
